import CrudActionSetBase from './CrudActionSetBase'

export class RegionActionSet extends CrudActionSetBase('region'){}
export default new RegionActionSet()